import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { BehaviourLabels } from '@linc-technologies/linced-common/enums/suspensions';

export const BehaviourType = BaseEnum.create({
  values: [
    { value: 1, label: 'Positive' },
    { value: 2, label: 'Neutral' },
    { value: 3, label: 'Negative' },
  ],
});

export const IncidentOutcome = BaseEnum.create({
  values: [
    { value: 0, label: 'Unresolved' },
    { value: 1, label: 'Incident Closed' },
    { value: 2, label: 'Suspension' },
    { value: 3, label: 'Expulsion' },
  ],
});

export const IncidentStatus = BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Open' },
    { value: 2, label: 'Closed' },
  ],
});

export const BehaviourCategoriesNSW = BaseEnum.create({
  values: [
    {
      value: 1,
      label: BehaviourLabels.CONTINUED_DISOBEDIENCE,
    },
    { value: 2, label: BehaviourLabels.MALICIOUS_DAMAGE },
    { value: 3, label: BehaviourLabels.VERBAL_ABUSE },
    { value: 4, label: BehaviourLabels.BULLYING_CYBERBULLYING },
    { value: 5, label: BehaviourLabels.MISUSE_OF_TECHNOLOGY },
    {
      value: 6,
      label: BehaviourLabels.DISCRIMINATION,
    },
    { value: 7, label: BehaviourLabels.OTHER_BEHAVIOUR_OF_CONCERN },
    {
      value: 8,
      label: BehaviourLabels.POSSESSION_OF_SUBSTANCES,
    },
    {
      value: 9,
      label: BehaviourLabels.POSSESSION_OF_ILLEGAL_SUBSTANCE,
    },
    {
      value: 10,
      label: BehaviourLabels.WEAPONS_POSSESSION_USE,
    },
    {
      value: 11,
      label: BehaviourLabels.IMPLEMENT_AS_WEAPON,
    },
    {
      value: 12,
      label: BehaviourLabels.THREATENING_VIOLENT_BEHAVIOUR,
    },
    {
      value: 13,
      label: BehaviourLabels.SERIOUS_CRIMINAL_BEHAVIOUR,
    },
    {
      value: 14,
      label: BehaviourLabels.SEXUAL_HARASSMENT,
    },
    { value: 15, label: BehaviourLabels.OTHER_SERIOUS_BEHAVIOUR },
    { value: 16, label: BehaviourLabels.OTHER },
  ],
});

export const BehavioursOfConcern = BaseEnum.create({
  values: [
    {
      value: 1,
      label: BehaviourLabels.CONTINUED_DISOBEDIENCE,
    },
    { value: 2, label: BehaviourLabels.MALICIOUS_DAMAGE },
    { value: 3, label: BehaviourLabels.VERBAL_ABUSE },
    { value: 4, label: BehaviourLabels.BULLYING_CYBERBULLYING },
    { value: 5, label: BehaviourLabels.MISUSE_OF_TECHNOLOGY },
    {
      value: 6,
      label: BehaviourLabels.DISCRIMINATION,
    },
    { value: 7, label: BehaviourLabels.OTHER_BEHAVIOUR_OF_CONCERN },
  ],
});

export const SeriousBehavioursOfConcern = BaseEnum.create({
  values: [
    {
      value: 8,
      label: BehaviourLabels.POSSESSION_OF_SUBSTANCES,
    },
    {
      value: 9,
      label: BehaviourLabels.POSSESSION_OF_ILLEGAL_SUBSTANCE,
    },
    {
      value: 10,
      label: BehaviourLabels.WEAPONS_POSSESSION_USE,
    },
    {
      value: 11,
      label: BehaviourLabels.IMPLEMENT_AS_WEAPON,
    },
    {
      value: 12,
      label: BehaviourLabels.THREATENING_VIOLENT_BEHAVIOUR,
    },
    {
      value: 13,
      label: BehaviourLabels.SERIOUS_CRIMINAL_BEHAVIOUR,
    },
    {
      value: 14,
      label: BehaviourLabels.SEXUAL_HARASSMENT,
    },
    { value: 15, label: BehaviourLabels.OTHER_SERIOUS_BEHAVIOUR },
  ],
});

export const IncidentTimePeriod = BaseEnum.create({
  values: [
    { value: 1, label: 'Unspecified' },
    { value: 2, label: 'AM' },
    { value: 3, label: 'PM' },
    { value: 4, label: 'Recess' },
    { value: 5, label: 'Before School' },
    { value: 6, label: 'After School' },
    { value: 7, label: 'Excursion' },
    { value: 8, label: 'Weekend' },
    { value: 9, label: 'Other' },
  ],
});

// deprecated
export function getBehaviourCategoriesForJurisdiction(jurisdiction: number) {
  switch (jurisdiction) {
    case Jurisdiction.AU_NSW:
      return BehaviourCategoriesNSW;
    //insert other jurisdictions here
    default:
      return BehaviourCategoriesNSW;
  }
}
